<template>
  <!-- Content -->
  <d-row>
    <d-col lg="8" xl="9">
      <d-card class="card-small mb-4">
        <!-- Card Header -->

        <d-list-group flush>
          <d-list-group-item class="p-3">
            <d-row>
              <d-col>
                <word-form ref="wordForm" />
              </d-col>
            </d-row>
          </d-list-group-item>
        </d-list-group>
      </d-card>
    </d-col>
  </d-row>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import { cloneDeep } from '_utils';
import WordForm from './WordForm.vue';
import { MODEL, _LOAD_MODEL_ } from './WordModel';

export default {
  name: 'Word-form',
  components: {
    WordForm,
  },
  data() {
    return {
      printType: '',
      winPrint: null,
    };
  },
  computed: {
    word() {
      const { word } = this.$store.state.word;
      if (word) {
        Events.$emit(_LOAD_MODEL_, word);
        return word;
      }
      return cloneDeep(MODEL);
    },
  },
  methods: {
    ...mapActions([
    ]),
    save() {
      this.$refs.wordForm.save();
    },
  },
  mounted() {

  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.print-link {
  color: $primary;
  text-decoration: underline;
  cursor: pointer;
}
</style>
<style lang="scss">
@media print {
  .pagebreak {
    clear: both;
    page-break-after: always;
  }
}
</style>
